module.exports = __webpack_public_path__ + "img/NBA_DoubleShot.25762ae7.png";